import React, { Fragment } from "react";
import ReportSummary from "../components/dashboard/ReportSummary";
import ReportLoadingIndicator from "../components/dashboard/ReportLoadingIndicator";
import { useOrganizationsByRole } from "../manage-organizations/organizationServices";
import { pipe, filter, length } from "ramda";

const getActiveCount = pipe(
  filter(org => org.active),
  length,
);

const OrganizationsByRoleReport = ({ role, primary, secondary }) => {
  const results = useOrganizationsByRole(role);

  return (
    <Fragment>
      {results.isSuccess ? (
        <ReportSummary
          primary={primary}
          secondary={secondary}
          count={getActiveCount(results.data)}
        />
      ) : (
        <ReportLoadingIndicator />
      )}
    </Fragment>
  );
};

export default OrganizationsByRoleReport;
